<template>
  <SUserLayout
    sidebarTitle="trips.title"
    sidebarIcon="mdi-ticket-confirmation"
    :sidebarItems="sidebarItems"
  >
    <div class="d-flex justify-content-center">
      <RouterView
        :currentTabName="currentTabName"
        :appConfig="appConfig"
        @update-trips-count="updateTripsCount"
      />
    </div>
  </SUserLayout>
</template>

<script lang="ts">
export default {
  name: 'TripsPage',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import SUserLayout from '@slg/web-customer-shared/src/components/layouts/userLayout/SUserLayout.vue';
import importedAppConfig from '@/appConfig';
import { useI18n, useRouteRef } from '@/composables';

const { t } = useI18n();
const route = useRouteRef();

const tripsCount = ref<{ cancelled: number | null; past: number | null; planned: number | null }>({
  cancelled: null,
  past: null,
  planned: null,
});
const appConfig = ref<Record<string, any>>({});

appConfig.value = importedAppConfig;

const currentTabName = computed(() => route.value.name);
const sidebarItems = computed(() => [
  {
    name: `${t('trips.planned')} ${tripsCount.value.planned !== null ? `(${tripsCount.value.planned})` : ''}`,
    route: 'planned',
  },
  {
    name: `${t('trips.past')} ${tripsCount.value.past !== null ? `(${tripsCount.value.past})` : ''}`,
    route: 'past',
  },
  {
    name: `${t('trips.canceled')} ${tripsCount.value.cancelled !== null ? `(${tripsCount.value.cancelled})` : ''}`,
    route: 'canceled',
  },
]);

function updateTripsCount(count: { cancelled: number | null; past: number | null; planned: number | null }) {
  tripsCount.value = count;
}
</script>
